module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"open_menu":"Open Menu","go_back":"Go Back"}}')
  delete Component.options._Ctor
}
